import Text from "./Text";
import {useModal} from "./Modal"
import Pong from "./Pong";

const Footer = ({textColor="text-black"}) => {
    const { ModalView, openModal } = useModal()
    let count = 0;

    const clickCounter = () =>{
        count += 1
        if(count === 7){
            openModal(<Pong/>)
            count = 0
        }
    }

    return(
    <div className="w-full flex justify-center">
        <div onClick={() => clickCounter()}>
            <ModalView/>
            <Text classNames={textColor}>© RayCraft Studios</Text>
        </div>
    </div>
    )
}

export default Footer;